(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('SectorPositionSearch', SectorPositionSearch);

    SectorPositionSearch.$inject = ['$resource'];

    function SectorPositionSearch($resource) {
        var resourceUrl =  'api/_search/sector-positions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
